import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Atividade } from 'src/app/core/atividade';
import { Rotas } from 'src/app/core/rotas';
import { FiltroAtividade } from "../../core/filtro/filtro-atividade";
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class AtividadeService extends BaseService<Atividade> {

    constructor(http: HttpClient) {
      super(http, Rotas.OFICINA);
    }

    getAllByArea(area: string) {
      const params: any = {};
      if (area) params.area = area;
      return this.http.get(Rotas.OFICINA, {params});
    }

    getByTurma(idTurma: number) {
      return this.http.get(Rotas.OFICINA + 'turma/' + idTurma);
    }


    getAllVigentesAndPassadas(area: string) {
      const params: any = {};
      if (area) params.area = area;
      return this.http.get(Rotas.OFICINA + 'vigente-e-passadas', {params});
    }

    getAllVigentesAndFuturas(area: string) {
      const params: any = {};
      if (area) params.area = area;
      return this.http.get(Rotas.OFICINA + 'vigente-e-futuras', {params});
    }

    getByFilter(filtro: FiltroAtividade) {
        const params: any = {};

        if (filtro.descricao) params.descricao = filtro.descricao;
        if (filtro.projeto) params.projeto = filtro.projeto.id;
        if (filtro.dataInicio) params.dataInicio = filtro.dataInicio.getTime();
        if (filtro.dataFim) params.dataFim = filtro.dataFim.getTime();
        if (filtro.area) params.area = filtro.area;
        return this.http.get(Rotas.OFICINA + "filter", {params});
    }

}
